
import { Outlet, Navigate } from "react-router-dom";
import AdminHeader from "./AdminHeader";
import { AdminSidebar } from "./AdminSidebar";
import { AdminBottomNav } from "./AdminBottomNav";
import { useAuth } from "@/contexts/AuthContext";
import { Skeleton } from "@/components/ui/skeleton";
import { useUI } from "@/contexts/UIContext";
import { cn } from "@/lib/utils";

const AdminLayout = () => {
  const { user, isAdmin, loading } = useAuth();
  const { isSidebarOpen, toggleSidebar } = useUI();

  // Show loading state while checking auth
  if (loading) {
    return (
      <div className="min-h-screen w-full flex bg-background">
        <div className="w-64 border-r p-4 space-y-4">
          {[...Array(6)].map((_, i) => (
            <Skeleton key={i} className="h-10 w-full" />
          ))}
        </div>
        <main className="flex-1 p-6">
          <Skeleton className="h-12 w-64 mb-6" />
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            {[...Array(4)].map((_, i) => (
              <Skeleton key={i} className="h-64 w-full rounded-lg" />
            ))}
          </div>
        </main>
      </div>
    );
  }

  // Redirect to home if not admin
  if (!user || !isAdmin) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="min-h-screen w-full bg-background">
      <AdminSidebar isOpen={isSidebarOpen} onToggle={toggleSidebar} />
      
      {/* Main Content */}
      <div className={cn(
        "min-h-screen transition-all duration-300 ease-in-out pb-16 lg:pb-0",
        isSidebarOpen ? "lg:ml-64" : "lg:ml-0" // Full width when sidebar closed on desktop
      )}>
        <AdminHeader />
        <main className="p-3 xs:p-4 sm:p-6 bg-background">
          <Outlet />
        </main>
      </div>
      <AdminBottomNav />
    </div>
  );
};

export default AdminLayout;
